/* eslint-disable */

import React, { FC, ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  title: ReactNode;
};

export const t = (title: string) => {
  return <RenderText title={title.toString()} />;
};

// @ts-ignore
const RenderText: FC<Props> = ({ title }) => {
  const { i18n } = useTranslation();
  // @ts-ignore
  return `${i18n.t(title)}`;
};
